import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import emailjs from '@emailjs/browser';

function Contact() {
  const [formData, setFormData] = useState({
    fullname: '',
    email: '',
    services: '',
    description: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitMessage('');

    try {
      // EmailJS configuration
      const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID;
      const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
      const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

      // Template parameters to send to EmailJS
      const templateParams = {
        from_name: formData.fullname,
        from_email: formData.email,
        services: formData.services,
        message: formData.description,
        to_name: 'Ansh Chopra'
      };

      await emailjs.send(serviceId, templateId, templateParams, publicKey);

      setSubmitMessage('Thank you for your message! We will get back to you soon.');
      setFormData({
        fullname: '',
        email: '',
        services: '',
        description: ''
      });
    } catch (error) {
      console.error('Error sending email:', error);
      setSubmitMessage('Sorry, there was an error sending your message. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Header />
      
      <section className="contact-section">
        <div className="container">
          <h1 className="contact-title">CONTACT<br/>WITH ME</h1>

          <div className="contact-content">
            <div className="contact-info">
              <div className="info-block">
                <h3>Office Location</h3>
                <p>Mohali, India</p>
              </div>

              <div className="info-block">
                <h3>Office Time</h3>
                <p>24/7 Available</p>
              </div>

              <div className="info-block">
                <h3>Support</h3>
                <p>anshworkofficial@gmail.com</p>
              </div>
            </div>

            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="fullname">Full Name</label>
                  <input 
                    type="text" 
                    id="fullname" 
                    name="fullname" 
                    placeholder="Ansh Chopra" 
                    value={formData.fullname}
                    onChange={handleChange}
                    required 
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="email">Email Address</label>
                  <input 
                    type="email" 
                    id="email" 
                    name="email" 
                    placeholder="anshchopra@gmail.com" 
                    value={formData.email}
                    onChange={handleChange}
                    required 
                  />
                </div>
              </div>

              <div className="form-group full-width">
                <label htmlFor="services">What services are you looking for?</label>
                <select 
                  id="services" 
                  name="services" 
                  value={formData.services}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select your services</option>
                  <option value="ux-design">UX Design and Prototyping</option>
                  <option value="ui-design">UI Design and Branding</option>
                  <option value="research">Research and Strategy</option>
                  <option value="development">Development</option>
                </select>
              </div>

              <div className="form-group full-width">
                <label htmlFor="description">Project Description</label>
                <textarea 
                  id="description" 
                  name="description" 
                  placeholder="Enter your description" 
                  value={formData.description}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>

              <button type="submit" className="btn btn-black" disabled={isSubmitting}>
                {isSubmitting ? 'Sending...' : 'Send it over'} <span className="btn-arrow">→</span>
              </button>

              {submitMessage && (
                <p style={{
                  marginTop: '20px',
                  padding: '15px',
                  borderRadius: '4px',
                  backgroundColor: submitMessage.includes('error') ? '#fee' : '#efe',
                  color: submitMessage.includes('error') ? '#c33' : '#363',
                  fontSize: '14px'
                }}>
                  {submitMessage}
                </p>
              )}
            </form>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default Contact;
